import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'quorum-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  localCall(stuff: any) {
    console.log('here');
    console.log(stuff);
  }
}
